import gustoLogo from "@/assets/gusto-logo.png";
import gustoLogoDark from "@/assets/gusto-logo-dark.png";
import gustoAvatar from "@/assets/gusto-avatar.png";
import { cn } from "@/lib/utils";

export const GustoLogo = ({ className, size = "md", variant = "light" }) => {
  const sizes = {
    xs: "h-4",
    sm: "h-6",
    md: "h-8",
    lg: "h-10",
    xl: "h-14",
  };
  return (
    <img
      src={variant === "dark" ? gustoLogoDark : gustoLogo}
      alt="Gusto"
      className={cn(sizes[size] || sizes.md, "w-auto", className)}
    />
  );
};

export const GustoIcon = ({ className }) => (
  <img
    src={gustoAvatar}
    alt="Gusto"
    className={cn("w-5 h-5 inline-block object-contain", className)}
  />
);

export { gustoLogo, gustoAvatar };
